module.exports = __webpack_public_path__ + "media/images/locations/sm/spain-84fba4570bde8ceaaa69c3d2b15dba37.jpg";